import { twMerge } from 'tailwind-merge'
import { forwardRef } from 'react'

const Card = forwardRef(({ children, className, ...props }, ref) => (
  <div ref={ref} className={twMerge('overflow-hidden rounded-lg w-full border border-border', className)} {...props}>
    {children}
  </div>
))

export default Card
